export default __webpack_public_path__ + "static/media/thumbs-down-solid.80e8d3b4.svg";